import { isEmpty } from 'lodash';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { MULTISELECT_COLUMNS } from '../constants'; 
import SVG_CLASS_NAME from '../constants/style';
import ICONS from '../images/items'; 

export function extractTransitions(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const transitions = [];

  for (let i = 0; i < view.byteLength; i += 9) {
    // '>HHHBH' 2-2-2-1-2
    const project = view.getUint16(i);
    const user = view.getUint16(i+2);
    const date = view.getUint16(i+4);
    const state = view.getUint8(i+6);
    const step = view.getUint16(i+7);

    const newRecord = [project, user, date, state, step];
    transitions.push(newRecord)
  }

  return transitions;
}

export function extractAdminStats(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const adminStats = [];

  for (let i = 0; i < view.byteLength; i += 8) {
    // '>HHL' 2-2-4
    const date = view.getUint16(i);
    const author = view.getUint16(i+2);
    const revision = view.getUint32(i+4);

    const newRecord = [date, author, revision];
    adminStats.push(newRecord)
  }

  return adminStats;
}

export function extractGlobalAdminStats(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const globalAdminStats = [];

  for (let i = 0; i < view.byteLength; i += 10) {
    // '>HHHL' 2-2-2-4
    const client = view.getUint16(i);
    const date = view.getUint16(i+2);
    const author = view.getUint16(i+4);
    const revision = view.getUint32(i+6);

    const newRecord = [client, date, author, revision];
    globalAdminStats.push(newRecord)
  }

  return globalAdminStats;
}

export function generateMultiselectOptions(data) {
  // eslint-disable-next-line no-param-reassign
  const result = MULTISELECT_COLUMNS.reduce((object, key) => {object[key] = []; return object}, {});
  data.forEach(project => 
    {MULTISELECT_COLUMNS.forEach(
      column => {
        if (!result[column].includes(project[column]) && !isEmpty(project[column])) {
          result[column].push(project[column])
        }})
    }
  );
  // sort multiselect options
  Object.keys(result).forEach(key => {result[key] = result[key].sort()});

  return result;
}

export function extractRights(arrayBuffer) {
  const view = new DataView(arrayBuffer);
  const rights = [];

  for (let i = 0; i < view.byteLength; i += 14) {
    // '>HHHLL' 2-2-2-4-4
    const user = view.getUint16(i);
    const projectPath = view.getUint16(i+2);
    const rightCode = view.getUint16(i+4);
    const stepRightsCount = view.getUint32(i+6);
    const hasRootRight = view.getUint32(i+10);

    const newRecord = [user, projectPath, rightCode, stepRightsCount, hasRootRight];
    rights.push(newRecord)
  }

  return rights;
} 

export function invertObject(object = {0:1}) {
  const invertedObject = {};
  Object.entries(object).forEach(([key, value]) => {invertedObject[value] = key;});
  return invertedObject;
}

export function applyMultiselect(data, list, dataKey) { 
  if (list.length) {
    return data.filter(obj => list.includes(obj[dataKey]));
  }
  return data; 
}

export function applySelectedDate(data, dates, dataKey) {
  if(dates.startDate && dates.endDate) {
    return data.filter(obj => {
      const projectDate = new Date(obj[dataKey]);
      return projectDate >= dates.startDate && projectDate <= dates.endDate;
    })
  }
  return data;
}

export function dateFilter(dates, startDate, endDate) {
  if (dates && startDate && endDate) {
    return dates.filter(
      date => {
        return date >= startDate && date <= endDate
      }
    ).length;
  }
  return dates.length;
}

export function applyFilters(data=[], filters, sortMethod, sortOrder) {
  let projects = [...data];

  filters.forEach(filter => {
    projects = filter(projects);
  });

  projects.sort((a, b) => sortMethod(a, b, sortOrder));

  return projects;
}

export function applySort(data=[], sortMethod, sortOrder) {
  const projects = {};
  
  Object
    .keys(data).sort((a, b) => sortMethod(a, b, data, sortOrder))
    .forEach(key => {
        projects[key] = data[key]
      }
    );

  return projects;
}

function renderMessageModal(messageModal, message, confirmText) {
  messageModal.fire({
    type: 'error',
    text: message,
    confirmButtonColor: '#AF6098',
    showConfirmButton: true,
    confirmButtonText: confirmText,
  });
}

export function convertDate(date) {
  return date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : ''
}

export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function convertUnits (value) {
  const decimals = 100;
  if (value < 1024) {
    return `${Math.round(value * decimals) / decimals} B`;
  }
  if (value >= 1024 && value < 1024 * 1024) {
    return `${Math.round((value * decimals) / 1024) / decimals} kB`;
  }
  if (value >= 1024 * 1024 && value < 1024 * 1024 * 1024) {
    return `${Math.round((value * decimals) / (1024 * 1024)) / decimals} MB`;
  }
  if (value >= 1024 * 1024 * 1024 && value < 1024 * 1024 * 1024 * 1024) {
    return `${Math.round((value * decimals) / (1024 * 1024 * 1024)) / decimals} GB`;
  }
  return `${Math.round((value * decimals) / (1024 * 1024 * 1024 * 1024)) / decimals} TB`;
}

export function convertBytesToGigabytes(value, decimals) {
  return Math.round((value * decimals) / (1024 * 1024 * 1024)) / decimals;
}

export function getSvgFaIcon(type) {
  switch (type) {
    case 'Completed':
      return 'search';
    case 'Reviewed':
      return 'check';
    case 'In_Process':
      return 'pen';
    case 'In process':
      return 'pen';
    case 'Locked':
      return 'lock';
    case 'Edited_After_Review':
      return 'check';

    default:
      return '';
  }
}

export function statusIconFormatter(value) {
  switch (getSvgFaIcon(value)) {
    case '':
      return value;

    default:
      return (
        <Row>
          <Col className="mr-1" md="1">
            <span title={`${value}`} className="fa-stack icon">
              <svg
                title={`${value}`}
                className={`svg-inline--fa fa-stack-1x icon ${SVG_CLASS_NAME[getSvgFaIcon(value)]}`}
                aria-labelledby="svg-inline--fa-title-1"
                data-prefix="fas"
                data-icon={getSvgFaIcon(value)}
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                data-fa-i2svg=""
                viewBox={ICONS[getSvgFaIcon(value)]['viewBox']}
                fill={ICONS[getSvgFaIcon(value)]['fill']}
              >
                <title id="svg-inline--fa-title-1">{value}</title>
                {ICONS[getSvgFaIcon(value)]['paths'][0]}
              </svg>
            </span>
          </Col>
          <Col>
            {value}
          </Col>
        </Row>
      );
  }
}

export default {
  extractTransitions,
  renderMessageModal,
  getSvgFaIcon,
  statusIconFormatter,
};
